<template>
  <main-layout>

    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-45-01"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
          <label slot="title">{{ $t("label.system.tenant.detail.tenant") }}</label>
          <sp-smart-button @click="backTenantSearch" slot="cancel">キャンセル</sp-smart-button>
          <narrow-down @click="tenantImport" slot="create">{{ "取り込み" }}</narrow-down>
      </head-title>
    </el-row>
    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{ $t("label.router.AddressBookImport") }}
      </div>
      <el-row>
        <el-form
          label-width="130px"
          label-position="left"
          ref="ruleForm"
          :rules="rules"
          :model="query">

          <!--  テナントID  -->
          <el-form-item
            :label="$t('label.system.tenant.detail.tenantExId')">
            <span class="span-type">
              {{tenant.exId}}
            </span>
          </el-form-item>

          <!--  テナント名  -->
          <el-form-item
            class="margin-top"
            :label="$t('label.system.tenant.detail.tenantName')">
            <span class="span-type">
              {{tenant.name}}
            </span>
          </el-form-item>

          <!--  CSVファイル -->
          <el-form-item
            class="margin-top item-height"
            :label="$t('label.system.tenant.detail.userCsvImport')"
            prop="fileName">
            <el-input
              :readonly="true"
              :placeholder="$t('label.system.tenant.detail.file')"
              v-model="query.fileName"
              class="input-width"
              >
            </el-input>
            <selectBtn class="selectBtns" @click="uploadfile">
              {{$t("label.system.tenant.detail.canzhao")}}
            </selectBtn>
            <input
              ref="csvUpload"
              type="file"
              style="display: none"
              accept=".csv,.CSV"
              @change="getCsvfile"/>
          </el-form-item>
        </el-form>
      </el-row>

      <!-- インポートが成功し、失敗数が表示されます  -->
      <div class="m-top-8">
        <div class="label-with float-left">
          <span class="color">
            {{ $t("label.system.tenant.search.result") }}
          </span>
        </div>
        <el-input
          id="textarea_result"
          :readonly="true"
          type="textarea"
          v-model="result.failureDetails.message"
          :autosize="{ minRows: 16, maxRows: 32 }"
          class="in-file-url-two float-left"
        >
        </el-input>
      </div>

      <loading-dialog :dialogVisible="showLoading" />

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
      >
      </el-dialog-prompt>

    </div>
  </main-layout>
</template>

<script>
import SystemManageApi from "@/api/SystemManageApi";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import selectBtn from "@/components/common/generalButton/Select";
import headTitle from "@/components/common/head/head"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import SpSmartButton from "@/components/common/sp-smart-button"
import NewDesignLayout from "@/layout/NewDesignLayout";
import Menubar from "@/components/leftmenu/DashBoard";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt"

export default {
  components: {
    LoadingDialog: LoadingDialog,
    selectBtn,
    headTitle,
    narrowDown,
    SpSmartButton,
    MainLayout: NewDesignLayout,
    Menubar,
    elDialogPrompt
  },
  data() {
    return {
      msgParam: this.$t('message.common.validation.fileFormat'),
      centerDialogVisibleIsShow: false,
      query: {
        file: null,
        fileName: null
      },
      result: {
        id: null,
        name: null,
        exId: null,
        successCount: null,
        failureCount: null,
        failureDetails: [
          {
            lineNo: null,
            message: null,
          },
        ],
      },
      showLoading: false,
      tenant:{
        id: null,
        exId: null,
        name: null,
      },
      resultstr: "",
      rules: {
        fileName: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: "CSVファイル",
            }),
          },
        ],
      }
    };

  },
  methods: {

    //ファイルファイルを取得
    getCsvfile() {
      let csvFile = this.$refs.csvUpload.files[0];
      var csvCheck = /\.(csv|CSV)$/;
      if (!csvCheck.test(csvFile.name)) {
        this.query.file = null;
      } else {

        this.query.file = csvFile;
        this.query.fileName = csvFile.name;
      }
      const isLt2M = csvFile.size / 1024 / 1024 < 15;
      if (!isLt2M) {
          this.query.fileName = null;
          this.$messageIotError(this.$t('message.common.error.ERR_FILE_SIZE_OVER_MSG',{size:'15M'}));
          return this.query.file = null
      }
      if (csvFile.size == 0) {
          this.query.fileName = null;
          this.$messageIotError(this.$t('message.common.error.ERR_FILE_EMPTY_MSG'));
          return this.query.file = null
      }
    },

    //アップロード入力ボックスを開きます
    uploadfile() {
      document.getElementById('textarea_result').value = null
      this.query.file = null
      this.query.fileName = null
      this.$refs.csvUpload.value = null
      this.$refs.csvUpload.click();
    },

    //キャンセル
    backTenantSearch() {
      this.$router.back(-1);
    },

    tenantImport() {

      if(this.query.file == null){
        this.msgParam = this.$t('message.common.validation.required', {
          field: this.$t('label.system.owner.salesMachine.file')
        })
        this.centerDialogVisibleIsShow = true
      }else{
        SystemManageApi.AddressBookImport({
          tenantId: this.tenant.id,
          csvFile: this.query.file,
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return this.query.file = null
          }
          if (data.body.failureCount > 0) {
                this.query.file = null
                this.query.fileName = null
                this.$refs.csvUpload.value = ''
              this.resultstr = this.$t('message.common.csvImport.ERR_FAILURE_MSG');
          } else {
              this.resultstr = this.$t('message.common.csvImport.INFO_SUCCESS_AMOUNT_MSG',{amount:data.body.successCount});
          }
          for (let i = 0; i < data.body.failureDetails.length; i++) {
            let failureDetail = data.body.failureDetails[i]
            this.resultstr = this.resultstr + "\r\n" + this.$t('message.common.csvImport.ERR_' + failureDetail.message + "_MSG",
                            {row:failureDetail.lineNo,
                             column:failureDetail.itemIndex
                            });
          }
          document.getElementById('textarea_result').value = this.resultstr
        });
      }
    }
  },
  created() {
    this.tenant = this.$getPageInfo("system","tenant","M-06-24","tenant")
    var breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/tenants/search",
        title: "label.router.Thetenant",
      },
      {
        path: "",
        title: "label.router.tenantDetail",
      },
      {
        path: "",
        title: "label.router.AddressBookSearch",
      },
      {
        path: "",
        title: "label.router.AddressBookImportBread",
      }
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
.margin-top{
  margin-top: 20px;
}
.in-file-url {
  width: 500px;
}
::v-deep .in-file-url-two {
  width: 596px;
  height: 237px;
  margin-bottom: 40px;
  .el-textarea__inner {
    min-height: 237px !important ;
    border-radius: 4px !important;
    width: 596px !important;
    height: 237px !important;
    background-color: #DEDED9 !important;
    box-shadow: none !important;
    border-radius: 6px !important;
  }
}
::v-deep input::-webkit-input-placeholder {
  font-size: 14px;
  color: #B8B8B4;
}
.in-files-results {
  height: 350px;
}

.button-padding-left {
  padding-left: 3em;
}

.text-style-size-color {
  font-size: 12px;
  color: #409eff;
  margin-left: 15px;
}

.image-size {
  width: 200px;
  height: 200px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}

.input-width {
  float:left;
  width: 200px;
}

.span-text-size-color {
  color: #606266;
  font-size: 13px;
  text-align: left;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.padding-right-meetingRoomName {
  padding-right: 30px;
}
.title {
  width: 200px;
  text-align: left;
  margin-bottom: 10px;
}
.image-size {
  width: 200px;
  height: 200px;
}
.display {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.displays {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.color {
  color: #525250;
  font-size: 16px;
}
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .zdyselect {
  width: 90px;
  font-size: 12px;
  height: 25px;
  border-radius: 15px;
  .el-input__inner {
    height: 25px;
    border-radius: 10px;
    border-color: #409eff;
    color: #409eff;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 0px !important;
  }
}
::v-deep .zdyInput {
  .el-input__inner {
    height: 30px;
    border-radius: 4px !important;
    color: #409eff;
    border: 2px solid;
    border-color: #bce0fd;
  }
  .el-input__inner::placeholder {
    color: #bce0fd;
  }
  .el-input__inner::-webkit-input-placeholder {
    color: #bce0fd;
  }
}
::v-deep .el-form-item-display {
  .el-form-item__content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    span {
      width: 60px;
      margin-left: 10px;
      color: #409eff;
    }
  }
}
.selectBtns {
  margin-left: 20px;
  float:left;
  width: 146px;
  height: 40px;
  line-height: 44px;
  ::v-deep .my-button {
    background-color: #F7F7F2 !important;
  }
}
::v-deep .margin-right-2 {
  .el-button--small {
    width: 86px;
  }
}
::v-deep .el-form-item__label {
  font-size: 12px;
}
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
::v-deep .el-input__inner{
  width: 324px;
  height: 44px !important;
  border-radius: 8px !important;
  background: #F2F2ED;
  border: none;
  box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
    4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
}
.input-width{
  width: 324px;
  height: 44px;
}
::v-deep .el-form-item__label {
  font-size: 16px;
  color: #525250;
}
.float-left {
  float:left;
}
::v-deep .el-form-item__label:before {
  display: none;
}
.span-type {
  color: #525250;
}

.label-with {
  width: 130px;
}
.item-height {
  ::v-deep .el-form-item__label {
    line-height: 44px;
  }
}
</style>
